import { Segmented } from 'antd'
import { useQueryClient } from '@tanstack/react-query'
import {
  canUseGlobalView,
  REGION_LABELS,
  type RegionView,
} from '@/config/regions'
import { useRegionStore } from '@/stores/regionStore'
import { cn } from '@/utils/cn'

export function RegionSwitcher({ className }: { className?: string }) {
  const queryClient = useQueryClient()
  const availableRegions = useRegionStore((s) => s.availableRegions)
  const view = useRegionStore((s) => s.view)
  const setView = useRegionStore((s) => s.setView)

  if (availableRegions.length === 0) return null

  const options: { label: string; value: RegionView }[] = availableRegions.map((r) => ({
    label: REGION_LABELS[r],
    value: r,
  }))
  if (canUseGlobalView(availableRegions)) {
    options.push({ label: 'Global', value: 'GLOBAL' })
  }

  if (options.length < 2) {
    return (
      <span className={cn('rfid-region-switcher rfid-region-switcher--solo', className)}>
        {REGION_LABELS[availableRegions[0]!]}
      </span>
    )
  }

  return (
    <Segmented
      size="small"
      className={cn('rfid-region-switcher', className)}
      value={view}
      options={options}
      onChange={(v) => {
        setView(v as RegionView)
        void queryClient.invalidateQueries()
      }}
    />
  )
}
